








import Vue from 'vue'
import { ITranslations } from '../store/state'

interface NumberOfHitsComputed {
	total: number, 
    query: string,
	show: boolean
    translations: ITranslations
}

export default Vue.extend<{}, {}, NumberOfHitsComputed, {}>({
	name: 'NumberOfHits',
	computed: {
		total() {
			return this.$store.getters.total
		},
        query() {
			return this.$store.getters.query
		},
        show() {
            return this.$store.getters.hasFilters || (this.$store.getters.query !== '' && this.$store.getters.query !== '*')
        },
        translations() {
			return this.$store.getters.translations
		}
	},
})
